import $ from 'jquery';
import datepickerFactory from 'jquery-datepicker';
import datepickerJAFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-ja';

datepickerFactory($);
datepickerJAFactory($);

//年・月・日・曜日を取得する
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() + 1;
const day = date.getDate();
const yearString = year.toString();
const monthString = month.toString().padStart(2, '0');
const dayString = day.toString().padStart(2, '0');
const today = yearString + monthString + dayString;
const todayNumber = Number(today);

$(function() {
  $.get("https://holidays-jp.github.io/api/v1/date.json", function(holidaysData) {
    $('#js-checkin').datepicker({
      buttonImageOnly: false,
      showOn: 'both',
      minDate: '+0d',
      onClose : function(date) {
        if ( date.length > 0 ) {
          const dateNumber = date.replace( /\//g , '');
          $('.p-top-reserve__item input[name="checkin_date"]').val((dateNumber));
        }
      },
      beforeShowDay: function(date) {
        if (date.getDay() == 0) {
          return [true, 'day-sunday', null];
        } else if (date.getDay() == 6) {
          return [true, 'day-saturday', null];
        }
        var holidays = Object.keys(holidaysData);
        for (var i = 0; i < holidays.length; i++) {
          var holiday = new Date(Date.parse(holidays[i]));
          if (holiday.getYear() == date.getYear() &&
              holiday.getMonth() == date.getMonth() &&
              holiday.getDate() == date.getDate()) {
              return [true, 'day-holiday', null];
          }
        }
        return [true, 'day-weekday', null];
      }
    });

    $('#js-checkin').datepicker('setDate', 'today');
    $('.p-top-reserve__item input[name="checkin_date"]').val((todayNumber));

    $('#js-datepicker--airline').datepicker({
      buttonImageOnly: false,
      showOn: 'both',
      minDate: '0',
      beforeShowDay: function(date) {
        if (date.getDay() == 0) {
          return [true, 'day-sunday', null];
        } else if (date.getDay() == 6) {
          return [true, 'day-saturday', null];
        }
    
        var holidays = Object.keys(holidaysData);
        for (var i = 0; i < holidays.length; i++) {
          var holiday = new Date(Date.parse(holidays[i]));
          if (holiday.getYear() == date.getYear() &&
              holiday.getMonth() == date.getMonth() &&
              holiday.getDate() == date.getDate()) {
              return [true, 'day-holiday', null];
          }
        }
        return [true, 'day-weekday', null];
      }
    });
    $('#js-datepicker--airline').datepicker('setDate', '+2d');
    $.datepicker.regional['ja'];
  })
});

const stayForm = document.querySelector('#stayForm');

if(stayForm){
  stayForm.addEventListener('submit', () => {
    // チェックインの日付
    const checkInDateVal = document.querySelector('.p-top-reserve__item input[name="checkin_date"]').value;
    const checkInDateArr = [];
    checkInDateArr[0] = checkInDateVal.substr(0, 4);
    checkInDateArr[1] = checkInDateVal.substr(4, 2);
    checkInDateArr[2] = checkInDateVal.substr(6, 2);
  
    // 泊数
    const nights = document.querySelector('#numOfNights').value;
  
    // チェックアウトの日付の計算
    const checkOutDate = document.querySelector('.p-top-reserve__item input[name="checkout_date"]');
    const checkOutDateCalc = new Date(checkInDateArr[0], parseInt(checkInDateArr[1], 10) - 1, checkInDateArr[2]);
    checkOutDateCalc.setDate(checkOutDateCalc.getDate() + parseInt(nights, 10));
    const checkout = checkOutDateCalc.getFullYear() + ('0' + (checkOutDateCalc.getMonth() + 1)).slice(-2) + ('0' + checkOutDateCalc.getDate()).slice(-2);
    checkOutDate.setAttribute('value', checkout);
  })
}